
import LocationPhoneInfo from '../../locations/search/elements/PhoneInfo.vue'
import LocationAddressInfo from '../../locations/search/elements/AddressInfo.vue'
import LocationOperationInfo from '../../locations/search/elements/OperationInfo.vue'
import ClockIcon from '../../_globals/vectors/ClockIcon.vue'
import HeartIcon from '../../_globals/vectors/HeartIcon.vue'
import HeartFilledIcon from '../../_globals/vectors/HeartFilledIcon.vue'
import DeliveryIcon from '../../_globals/vectors/DeliveryIcon.vue'
import PickupIcon from '../../_globals/vectors/PickupIcon.vue'
import ReservationIcon from '../../_globals/vectors/ReservationIcon.vue'

export default {
  name: 'SignUpLocationCard',
  components: {
    LocationPhoneInfo,
    LocationAddressInfo,
    LocationOperationInfo,
    ClockIcon,
    HeartIcon,
    HeartFilledIcon,
    DeliveryIcon,
    PickupIcon,
    ReservationIcon,
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    selectLocation: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    select(data) {
      this.selectLocation(data)
    }
  }
}
